import "./SignInMain.css";
import React, { useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import google_login from '../../images/google_login.webp'
import post from '../../Api/Config/PostConfig';
import { getUser, loginUser, createUser } from '../../Api/UserApi';
import { useNavigate } from "react-router-dom";
import { setLoggedUser, setAuthToken, setMembership, setInstitution, setLicense } from '../../Storage/Setter';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { User } from '../../Models/User';
import { TEXT_BOX_COLOR, TEXT_BOX_VARIANT, FORM_BUTTON_VARIANT } from '../../Helper/FormConstants';
import * as validator from '../../Helper/Validator';
import { Link } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import { textAlign } from '@mui/system';
import { Card, CardContent, CardHeader, CardMedia, Divider, InputLabel } from '@mui/material';
import SingleTextInput from "../../Components/SingleTextInput";
import axios from 'axios';
import { UserConfig } from "../../Models/UserConfig";


var user = new User();

const GOOGLE_CLIENT_ID = "143447803615-3aobk4d9cc1vglfitliv1r1nk020vung.apps.googleusercontent.com";

// Google's sign-in script (~100 KB) is loaded on demand (button hover/focus/touch, or click),
// not on every page load. Same implicit token flow @react-oauth/google's useGoogleLogin used.
let gsiPromise;
const loadGoogleSignIn = () => gsiPromise || (gsiPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.onload = resolve;
    script.onerror = () => { gsiPromise = null; reject(new Error('Google sign-in failed to load')); };
    document.head.appendChild(script);
}));


const SigninMain = (props) => {
    const [userObj, setUserObj] = React.useState(user);
    const [formErrors, setFormErrors] = React.useState([]);
    const [showOtp, setShowOtp] = React.useState(false);
    const [incCounter, setIncCounter] = React.useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get('https://api.ipify.org?format=json')
            .then(res => {
                const clientIp = res.data.ip;
                userObj["current_login_ip"] = clientIp;
            })
            .catch(err => setIp('Error fetching IP'));
    }, []);

    const googleLogin = () => {
        loadGoogleSignIn()
            .then(() => window.google.accounts.oauth2.initTokenClient({
                client_id: GOOGLE_CLIENT_ID,
                scope: 'openid profile email',
                callback: (res) => res.error ? console.log('Login Failed:', res) : getUserProfile(res),
            }).requestAccessToken())
            .catch(() => props.triggerToastMessage({ isOpen: true, text: 'Could not load Google sign-in. Please try again.', level: 'error' }));
    };

    const getUserProfile = (user) => {
        if (user) {
            axios
                .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
                    headers: {
                        Authorization: `Bearer ${user.access_token}`,
                        Accept: 'application/json'
                    }
                })
                .then((res) => {
                    let data = res.data;
                    let uObj = new User();
                    uObj.email = data["email"]
                    uObj.first_name = data["given_name"]
                    uObj.last_name = data["family_name"]
                    uObj.google_profile_img = data["picture"]
                    uObj.config = new UserConfig()
                    uObj.google_login = true
                    uObj.google_access_token = user.access_token
                    userLogin(uObj, true);
                })
                .catch((err) => props.triggerToastMessage({ isOpen: true, text: 'Could not fetch your Google profile. Please try again.', level: 'error' }));
        }
    }

    const userLogin = (user, googleLogin) => {
        if (!googleLogin) {
            user.google_login = false;
            user.institution_login = true;
        }
        post(loginUser(), user).then(function (result) {
            if (result.statusCode == 200) {
                // Authentication successful and user also activated
                setLoggedUser(JSON.stringify(result.data["user"]));
                setMembership(JSON.stringify(result.data["membership"]));
                setLicense(JSON.stringify(result.data["license"]));
                setInstitution(JSON.stringify(result.data["institution"]))
                setAuthToken(result.data["user"].current_auth_token);
                if (result.data["user"].points_module_enabled) {
                    props.setPointsAvailable(result.data["user"]["points_balance"]);
                }
                props.showNavBar(true);
                props.triggerToastMessage({ isOpen: true, text: 'Login Success', level: 'success' });
                if (result.data["user"].force_login) {
                    navigate('/changePassword');
                }
                else if (result.data["user"].login_count === 1) {
                    // First login after signup -> prompt to apply a membership code
                    navigate('/membership');
                }
                else {
                    navigate('/studyList');
                }
            }
            else if (result.statusCode == 400) {
                // Invalid credentials
                props.triggerToastMessage({ isOpen: true, text: result.message, level: 'error' });
            }
            else {
                // Any other failure (404/401/403/500/empty) - surface it instead of
                // silently doing nothing, which looked like the page "just refreshing".
                props.triggerToastMessage({ isOpen: true, text: (result && result.message) ? result.message : 'Sign in failed. Please try again.', level: 'error' });
            }
        })

    }

    const handleUserInput = (event) => {
        setUserObj(prevState => ({
            ...prevState,
            [event.target.name]: event.target.value
        }))
    }

    return (
  <>
    <Grid container spacing={2} mt={4}>
      {/* Institution Login Card */}
      <Grid item xs={12} md={15}>
        <Card
          variant="outlined"
          sx={{
            borderRadius: 2,
            marginTop: -9, // keeping card height same
          }}
        >
          <CardContent>
            {/* Institution Login Section */}
            <Typography variant="h6" gutterBottom>
              Institution Login
            </Typography>

            <Typography
              variant="body2"
              sx={{ mb: 1, lineHeight: 1.5 }}
            >
              If you are part of the institution that has bought a license,
              please login using your institution email address.
            </Typography>

            <ValidatorForm
              onSubmit={() => userLogin(userObj, false)}
              onError={(errors) => setFormErrors(errors)}
            >
              <SingleTextInput
                title="Enter your email address"
                placeholder="Email address"
                name="email"
                value={userObj.email}
                validators={validator.emailRequired.validators}
                errorMessages={validator.emailRequired.errorMessages}
                onChange={handleUserInput}
              />

              <SingleTextInput
                title="Enter your password"
                placeholder="Password"
                name="password"
                type="password"
                value={userObj.password}
                validators={validator.requiredPassword.validators}
                errorMessages={validator.requiredPassword.errorMessages}
                onChange={handleUserInput}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 2,
                  textTransform: "none",
                  background: "#1971c2",
                  "&:hover": { background: "#115293" },
                }}
              >
                Sign in
              </Button>

              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                mt={1}
              >
                <Link to="/forgotPassword">Forgot password?</Link>
              </Grid>

              {/* Divider Between Login Methods */}
              <Divider sx={{ my: 0}}>
                <Typography variant="body2" color="textSecondary">
                  OR
                </Typography>
              </Divider>

              {/* Google Login Section */}
              <Typography
                variant="body2"
                sx={{ mb: 1.5, lineHeight: 1.5 }}
              >
                If you are here for a subscription for your individual use,
                sign in using your Google account.
              </Typography>

              <Button
                fullWidth
                variant="contained"
                onClick={googleLogin}
                onPointerEnter={loadGoogleSignIn}
                onFocus={loadGoogleSignIn}
                onTouchStart={loadGoogleSignIn}
                startIcon={<img src={google_login} width={25} height={25} alt="" />}
                sx={{
                  mt: 1,
                  background: "#db4437",
                  "&:hover": { background: "#c33d2e" },
                  textTransform: "none",
                }}
              >
                Sign in with Google
              </Button>
            </ValidatorForm>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  </>
);
};

export default SigninMain;